// src/i18n/en/arrivals.ts
// English mirror of es/arrivals.ts.
export const arrivals = {
  name: "Today's arrivals",
  tabs: {
    today: 'Today',
    tomorrow: 'Tomorrow',
  },
  pendingOnly: 'Pending only',
  emptyState: {
    description: 'Try widening the date or clearing "Pending only".',
  },
  updatedAgo: 'Updated %{seconds} s ago',
  wallScreen: 'Wall screen',
  wallScreenNeedsHotel: 'Choose a single hotel to open the wall screen.',
  operatorCode: 'Operator code',
  operatorCodeChoose: 'Choose the dispenser',

  // Arrivals list of the wall screen (mockup 02).
  wallList: {
    title: "Today's arrivals (%{count})",
    guest: 'Guest',
    reservation: 'Reservation',
  },

  liveStrip: {
    title: 'Right now',
    empty: 'Nobody in progress right now.',
    minutesInSection: '%{section} · %{minutes} min',
  },

  counters: {
    arrivals: "Today's arrivals",
    arrivalsKnown: 'Known (used a channel)',
    arrivalsKnownShort: 'Known',
    arrivalsKnownHint: 'Only guests who have used a channel are counted.',
    title: 'Arrival status',
    ready: 'Ready',
    preCheckInPartial: 'Pre-check-in partial',
    notStarted: 'Not started',
    checkedIn: 'Checked in',
    attention: 'Need attention',
  },

  columns: {
    time: 'Time',
    guest: 'Guest',
    room: 'Room',
    preCheckIn: 'Pre-check-in',
    payment: 'Payment',
    identification: 'Ident.',
    state: 'State',
    key: 'Key',
  },

  preCheckIn: {
    done: 'Done',
    doneAgo: 'Done · %{time} ago',
    doneToday: 'Done · today',
    partial: 'Partial',
    partialAt: 'Partial · %{section}',
    none: '—',
  },
  payment: {
    paid: 'Paid',
    pending: 'Pending',
    failed: 'Failed',
    none: '—',
  },
  key: {
    card: 'Card',
    digital: 'Digital key',
    none: '—',
  },

  stuckFlag: '%{minutes} min in %{section}',
  needsHelp: 'Needs help',

  actions: {
    acknowledge: 'Acknowledge',
    acknowledged: 'Acknowledged',
    pin: 'Pin',
    unpin: 'Unpin',
  },


  detail: {
    title: 'Reservation detail',
    close: 'Close',
    openFull: 'Open full record',
  },

  help: {
    title: "Today's arrivals",
    description: "The reception control panel: who arrives today, who is at a kiosk right now, and who needs help.",
    features: {
      liveStrip: 'The "Right now" strip counts the active sessions on each channel and shows first whoever needs help or has spent too long on a step.',
      sortOrder: 'The table puts first whoever needs help, then whoever has spent too long on a step, and the rest by arrival date and guest name.',
      actions: 'Acknowledge or pin a row to keep a close eye on it.',
    },
    tips: {
      pendingOnly: 'Use "Pending only" to hide what is already resolved.',
      wallScreen: 'Open "Wall screen" for a summary on a reception display.',
      operatorCode: 'With "Operator code" you get the code of the day that opens the operator menu of a key dispenser of your hotel.',
    },
  },
};

export default arrivals;
